// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__kWwNA","sideBar":"Search_sideBar__Ww2K3","main":"Search_main__hs9pW"};